export default function Footer() {
  const menuItems = [
    { label: 'Inicio', href: '#inicio' },
    { label: 'Nuestra Cafetería', href: '#cafeteria' },
    { label: 'Carta', href: '#carta' },
    { label: 'Menú', href: '#menu' },
    { label: 'Catálogo Ropa', href: '#ropa' },
    { label: 'Galería', href: '#galeria' },
    { label: 'Ubicación', href: '#ubicacion' },
    { label: 'Contacto', href: '#contacto' }
  ];

  const redesSociales = [
    { icon: 'ri-whatsapp-line', url: 'https://wa.me/56994347092', label: 'WhatsApp' },
    { icon: 'ri-instagram-line', url: 'https://instagram.com/lacasonadedonjuan', label: 'Instagram' },
    { icon: 'ri-facebook-line', url: 'https://facebook.com/lacasonadedonjuan', label: 'Facebook' }
  ];

  const handleMenuClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-emerald-800 text-white py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          {/* Info */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <div className="w-12 h-12 flex items-center justify-center text-white">
                <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                  {/* Montañas de fondo */}
                  <path d="M2 28L12 18L18 24L24 18L30 24L36 18L46 28" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                  
                  {/* Casona/Cabaña */}
                  <path d="M14 32L24 24L34 32V42H14V32Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M19 42V36H29V42" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                  <rect x="18" y="28" width="4" height="4" stroke="currentColor" strokeWidth="1.5"/>
                  <rect x="26" y="28" width="4" height="4" stroke="currentColor" strokeWidth="1.5"/>
                  
                  {/* Taza de café (detalle sutil) */}
                  <path d="M38 34H40C41.1046 34 42 34.8954 42 36C42 37.1046 41.1046 38 40 38H38" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round"/>
                  <path d="M34 34H38V40C38 41.1046 37.1046 42 36 42C34.8954 42 34 41.1046 34 40V34Z" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M35 32C35 32 35.5 30 36 30C36.5 30 37 32 37 32" stroke="currentColor" strokeWidth="1" strokeLinecap="round"/>
                </svg>
              </div>
              <div>
                <h3 className="font-bold text-xl">Cafetería Boutique La Casona</h3>
                <p className="text-sm text-emerald-200">Coyhaique · Patagonia Chilena</p>
              </div>
            </div>
            <p className="text-emerald-100 text-sm leading-relaxed mb-4">
              Café de especialidad, pastelería artesanal y vitrina de ropa seleccionada en el corazón de la Patagonia.
            </p>
            <div className="space-y-2 text-sm">
              <p className="text-emerald-100">
                <i className="ri-phone-line mr-2"></i>
                +56 9 9434 7092
              </p>
              <p className="text-emerald-100">
                <i className="ri-map-pin-line mr-2"></i>
                Calle Presidente Carlos Ibáñez 290
              </p>
              <p className="text-emerald-100 pl-6">
                Coyhaique, 5950000, AI, CL
              </p>
            </div>
          </div>

          {/* Links rápidos */}
          <div>
            <h4 className="font-bold text-lg mb-4">Navegación</h4>
            <ul className="space-y-2">
              <li>
                <a href="#inicio" className="text-emerald-100 hover:text-white transition-colors cursor-pointer">
                  Inicio
                </a>
              </li>
              <li>
                <a href="#cafeteria" className="text-emerald-100 hover:text-white transition-colors cursor-pointer">
                  Nuestra Cafetería
                </a>
              </li>
              <li>
                <a href="#carta" className="text-emerald-100 hover:text-white transition-colors cursor-pointer">
                  Carta
                </a>
              </li>
              <li>
                <a href="#ropa" className="text-emerald-100 hover:text-white transition-colors cursor-pointer">
                  Catálogo Ropa
                </a>
              </li>
              <li>
                <a href="#ubicacion" className="text-emerald-100 hover:text-white transition-colors cursor-pointer">
                  Ubicación
                </a>
              </li>
              <li>
                <a href="#contacto" className="text-emerald-100 hover:text-white transition-colors cursor-pointer">
                  Contacto
                </a>
              </li>
            </ul>
          </div>

          {/* Redes Sociales */}
          <div>
            <h4 className="font-bold text-lg mb-4">Síguenos</h4>
            <div className="flex gap-3 mb-6">
              {redesSociales.map((red) => (
                <a
                  key={red.label}
                  href={red.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-12 h-12 flex items-center justify-center bg-emerald-700 hover:bg-amber-600 rounded-full transition-all hover:scale-110 cursor-pointer"
                  aria-label={red.label}
                >
                  <i className={`${red.icon} text-xl`}></i>
                </a>
              ))}
            </div>
          </div>
        </div>

        {/* Aviso */}
        <div className="border-t border-emerald-700 pt-8">
          <div className="bg-emerald-700/50 rounded-xl p-4 mb-6">
            <p className="text-sm text-emerald-100 text-center">
              <i className="ri-information-line mr-2"></i>
              Catálogo de ropa sujeto a disponibilidad. Consulta stock actualizado por WhatsApp.
            </p>
          </div>

          {/* Copyright */}
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-emerald-200">
            <p>© 2025 Cafetería Boutique La Casona · Coyhaique · Patagonia Chilena · Todos los derechos reservados</p>
            <a 
              href="https://readdy.ai/?ref=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="hover:text-amber-400 transition-colors cursor-pointer"
            >
              Website Builder
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
